import { notFound } from "./not-found";
export const PARALLEL_ROUTE_DEFAULT_PATH = "next/dist/client/components/parallel-route-default";
export default function ParallelRouteDefault() {
    notFound();
}

//# sourceMappingURL=parallel-route-default.js.map